var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFaqQuest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#5F9E87"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13C8.44781 13 8 13.4322 8 13.9652V14.0348C8 14.5678 8.44781 15 9 15C9.55219 15 10 14.5678 10 14.0348V13.9652C10 13.4322 9.55219 13 9 13Z",
    fill: "#FAF5F0",
    stroke: "#FAF5F0",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.97258C12 5.33334 10.6542 4 9.00001 4C7.34587 4 6 5.33355 6 6.97258C6 7.30522 6.27224 7.57497 6.60795 7.57497C6.94366 7.57497 7.2159 7.30522 7.2159 6.97258C7.2159 5.99776 8.01621 5.20477 9.00001 5.20477C9.98382 5.20477 10.7841 5.99776 10.7841 6.97258C10.7841 7.9474 9.98382 8.74039 9.00001 8.74039C8.66431 8.74039 8.39206 9.01013 8.39206 9.34277C8.39206 9.37358 8.38363 11.3976 8.38363 11.3976C8.38363 11.7302 8.65587 12 8.99158 12C9.32729 12 9.59953 11.7302 9.59953 11.3976V9.88527C10.9674 9.60931 12 8.40839 12 6.97258Z",
    fill: "#FAF5F0",
    stroke: "#FAF5F0",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaqQuest);
export default __webpack_public_path__ + "static/media/icon-faq-quest.0d1cd48c839c259f8f3e4dd9e8fdf14d.svg";
export { ForwardRef as ReactComponent };